document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.announcement-bar');
  if (!container) return;

  const slides = container.querySelectorAll('.announcement-slide');
  const prevBtn = container.querySelector('.prev-btn');
  const nextBtn = container.querySelector('.next-btn');
  
  // Settings
  const autoPlay = container.getAttribute('data-autoplay') === 'true';
  const delay = parseInt(container.getAttribute('data-delay')) || 5000;
  
  let currentIndex = 0;
  let slideInterval;

  if (slides.length < 2) {
    if(prevBtn) prevBtn.style.display = 'none';
    if(nextBtn) nextBtn.style.display = 'none';
    return; 
  } else {
    if(prevBtn) prevBtn.style.display = '';
    if(nextBtn) nextBtn.style.display = '';
    return; 
  }

  function showSlide(index) {
      slides.forEach(slide => slide.classList.remove('active'));
      slides[index].classList.add('active');
  }

  function nextSlide() {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
  }

  function prevSlide() {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(currentIndex);
  }

  function startAutoPlay() {
    if (autoPlay) {
      slideInterval = setInterval(nextSlide, delay);
    }
  }

  function stopAutoPlay() {
    if (slideInterval) clearInterval(slideInterval);
  }

  nextBtn.addEventListener('click', () => {
    stopAutoPlay();
    nextSlide();
    startAutoPlay();
  });

  prevBtn.addEventListener('click', () => {
    stopAutoPlay();
    prevSlide();
    startAutoPlay();
  });

  if (autoPlay) {
    container.addEventListener('mouseenter', stopAutoPlay);
    container.addEventListener('mouseleave', startAutoPlay);
    startAutoPlay();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(min-width: 990px)').matches) return;

  const menu = document.querySelector('.head-mega-menu');
  if (!menu) return;

  const closeButton = menu.querySelector('.mega-menu-button-dismiss');

  let isKeyboard = false;

  document.addEventListener('keydown', () => {
    isKeyboard = true;
  });

  document.addEventListener('mousedown', () => {
    isKeyboard = false;
  });

  function closeAll() {
    menu
      .querySelectorAll('.mega-menu-submenu[aria-expanded="true"]')
      .forEach(submenu => {
        submenu.setAttribute('aria-expanded', 'false');
      });
  }

  function toggleSubmenu(li) {
    if (!li) return;

    const submenu = li.querySelector(':scope > .mega-menu-submenu');
    if (!submenu) return;

    const isOpen = submenu.getAttribute('aria-expanded') === 'true';

    li.parentElement
      .querySelectorAll(':scope > li')
      .forEach(siblingLi => {

        if (siblingLi === li) return;

        const siblingSubmenu = siblingLi.querySelector(':scope > .mega-menu-submenu');

        if (siblingSubmenu) {
          siblingSubmenu.setAttribute('aria-expanded', 'false');
        }

        siblingLi.classList.remove('active');
      });

    submenu.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    li.classList.toggle('active', !isOpen);
  }

  menu.querySelectorAll('.has-sub-menu > a').forEach(link => {
    const li = link.closest('.mega-menu-nav-item');

    link.addEventListener('focus', () => {
      if (!isKeyboard) return;
      toggleSubmenu(li);
    });

    link.addEventListener('click', e => {
      e.preventDefault();
      toggleSubmenu(li);
    });
  });

  const details = menu.querySelector('details');
  if (details) {
    details.addEventListener('toggle', () => {
      if (!details.open) {
        closeAll();
      }
    });
  }

  document.addEventListener('click', e => {
    if (!menu.contains(e.target)) {
      closeAll();
    }
  });

  closeButton.addEventListener('click', e => {
    closeAll();
    document.body.classList.remove('drawer-open', 'mega-menu-open');
    setTimeout(() => {
      document.querySelector('.header__shop details').removeAttribute('open');
		}, 200);
  });

  document.addEventListener('keyup', e => {
    if (e.key === 'Escape') {
      closeAll();
    }
  });
});

function getFacetHeight(wrapper) {
  if (window.innerWidth < 750) return null;

  const items = wrapper?.querySelectorAll('li');
  if (!items.length) return null;

  const count = Math.min(7, items.length);

  const styles = getComputedStyle(wrapper);
  const gap = parseFloat(styles.rowGap || styles.gap || 0);

  let height = 0;
  for (let i = 0; i < count; i++) {
    height += items[i].offsetHeight;
  }

  return height + gap * (count - 1);
}

function applyFacetHeight(wrapper) {
  const height = getFacetHeight(wrapper);
  if (height) wrapper.style.maxHeight = `${height}px`;
}

function resetFacetHeight(wrapper) {
  wrapper.style.maxHeight = '';
}

function toggleDescription(sectionId) {
  const wrapper = document.getElementById('DescriptionWrapper-' + sectionId);
  const btn = document.getElementById('ReadMoreBtn-' + sectionId);
  if (!wrapper || !btn) return;

  const isExpanded = wrapper.classList.contains('description-expanded');
  const isFacetList = wrapper.classList.contains('facets__list');

  if (isExpanded) {
    wrapper.classList.remove('description-expanded');
    wrapper.classList.add('description-truncated');
    btn.textContent = 'View More';
    if (isFacetList) applyFacetHeight(wrapper);

  } else {
    wrapper.classList.remove('description-truncated');
    wrapper.classList.add('description-expanded');
    btn.textContent = 'View Less';
    if (isFacetList) wrapper.style.maxHeight = '';
  }
}

function initFacetHeights() {
  if (window.innerWidth < 750) return;
  document.querySelectorAll('.description-truncated.facets__list').forEach(el => applyFacetHeight(el));
}

document.addEventListener('DOMContentLoaded', initFacetHeights);
window.addEventListener('resize', initFacetHeights);

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.footer-block.newsletter__form .newsletter-form, .template-page-contact .contact-form__bottom .button, .template-page-services .contact-form__bottom .button');
  if (!form) return;

  const button = form.querySelector('button[type="submit"]');

  form.addEventListener('submit', () => {
    button.classList.add('loading');
    button.disabled = true;
  });
});

document.addEventListener("click", function (e) {
  const closeBtn = e.target.closest('[id^="ModalClose-"]');
  if (!closeBtn) return;

  const modal = closeBtn.closest('product-modal');
  if (modal) modal.hide();
});

/* B2B Registration Form code Start */

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('RegistrationForm');
  if(!form) return;

  new Shopify.CountryProvinceSelector(
    'billing_country',
    'billing_province',
    { hideElement: null }
  );

  new Shopify.CountryProvinceSelector(
    'shipping_country',
    'shipping_province',
    { hideElement: null }
  );

  const checkbox = form.querySelector('#same_as_billing');

  const billingFields = {
    address: form.querySelector('#billing_address'),
    city: form.querySelector('#billing_city'),
    country: form.querySelector('#billing_country'),
    state: form.querySelector('#billing_province'),
    zip: form.querySelector('#billing_zip'),
  };

  const shippingFields = {
    address: form.querySelector('#shipping_address'),
    city: form.querySelector('#shipping_city'),
    country: form.querySelector('#shipping_country'),
    state: form.querySelector('#shipping_province'),
    zip: form.querySelector('#shipping_zip'),
  };

  // Default checked
  checkbox.checked = true;

  checkbox.addEventListener('change', function () {
    if (this.checked) {
      shippingFields.address.value = billingFields.address.value || '';
      shippingFields.city.value = billingFields.city.value || '';
      shippingFields.country.value = billingFields.country.value || '';

      shippingFields.country.dispatchEvent(new Event('change'));

      setTimeout(() => {
        shippingFields.state.value = billingFields.state.value || '';
        shippingFields.zip.value = billingFields.zip.value || '';
      }, 300);

      $('.shipping_address_wrapper').addClass('hidden');
    } else {
      $('.shipping_address_wrapper').removeClass('hidden');
    }
  });

  // Trigger once on load
  checkbox.dispatchEvent(new Event('change'));


  const companyRow = form.querySelector('.company-name-row');
  const companyIdRow = form.querySelector('.company-id-row');
  const companyInput = form.querySelector('#company');
  const companyIdInput = form.querySelector('#customer_account_number');

  function toggleConditionalField(row, input, show, required) {
    if (!row || !input) return;
    row.classList.toggle('hidden', !show);
    if(show == false){
      input.value = null;
      input.setAttribute('value', '');
    }
    if (required) {
      input.setAttribute('required', 'required');
    } else {
      input.removeAttribute('required');
    }
  }

  const taxCertInput = form.querySelector('#tax_certificate');
  const taxCertHint = form.querySelector('.tax-cert-hint');

  function updateTaxCertRequirement() {
    const businessYes = form.querySelector('.q-business:checked');
    const accountYes = form.querySelector('.q-account:checked');
    const bothNo = businessYes && businessYes.value === 'No' && accountYes && accountYes.value === 'No';

    if (!taxCertInput) return;
    // if (bothNo) {
    //   taxCertInput.removeAttribute('required');
    //   if (taxCertHint) taxCertHint.textContent = '(optional)';
    // } else {
    //   taxCertInput.setAttribute('required', 'required');
    //   if (taxCertHint) taxCertHint.textContent = '(required)';
    // }
  }

  form.querySelectorAll('.q-business').forEach(function (r) {
    r.addEventListener('change', function () {
      toggleConditionalField(companyRow, companyInput, this.checked && this.value === 'Yes', true);
      updateTaxCertRequirement();
    });
  });

  form.querySelectorAll('.q-account').forEach(function (r) {
    r.addEventListener('change', function () {
      toggleConditionalField(companyIdRow, companyIdInput, this.checked && this.value === 'Yes', true);
      updateTaxCertRequirement();
    });
  });

  updateTaxCertRequirement();

});

$(document).ready(function () {
  const registerForm = $('#RegistrationForm');
  if(!registerForm) return;

  $('#RegistrationForm input[type="text"]').on('input', function () {
    this.value = this.value.replace(/[<>]/g, '');
  });

  $.validator.addMethod(
    'phoneCustom',
    function (value, element) {
      const phoneRegex = /^\+?[0-9\s\-()]+$/;
      const digits = value.replace(/\D/g, '');
      return this.optional(element) || (phoneRegex.test(value) && digits.length >= 7 && digits.length <= 15);
    },
    'Enter a valid phone number'
  );

  $.validator.addMethod(
    'fileType',
    function (value, element) {
      if (this.optional(element)) return true;

      const allowed = ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'jpeg', 'jpg', 'png'];
      const fileName = element.files[0].name.toLowerCase();
      const ext = fileName.split('.').pop();

      return allowed.includes(ext);
    },
    'Invalid file type'
  );

  function trimValue(value) {
    return $.trim(value);
  }

  $('#RegistrationForm #phone').on('input', function (e) {
    const input = this;
    let cursorPos = input.selectionStart;

    let oldValue = input.value;

    let digits = oldValue.replace(/\D/g, '').substring(0, 10);

    let formatted = digits.replace(
      /(\d{0,3})(\d{0,3})(\d{0,4})/,
      (_, a, b, c) =>
        `${a ? `(${a}` : ''}${a.length === 3 ? ')' : ''}${b ? ' ' + b : ''}${c ? ' ' + c : ''}`
    );

    input.value = formatted;

    let newLength = formatted.length;
    let oldLength = oldValue.length;

    cursorPos += newLength - oldLength;

    input.setSelectionRange(cursorPos, cursorPos);
  });

  registerForm.validate({
    errorElement: 'span',
    errorClass: 'form-error',
    ignore: ':hidden:not(#agree_terms)',

    errorPlacement: function (error, element) {
      if (element.attr('type') === 'checkbox') {
        element.closest('.checkbox-field').append(error);
      } else {
        element.closest('.form-field').append(error);
      }
    },

    highlight: function (element) {
      $(element).css('border-color', 'red');
    },

    unhighlight: function (element) {
      $(element).css('border-color', '');
    },

    rules: {
      'contact[name]': { required: true, normalizer: trimValue },
      'contact[email]': { required: true, email: true, normalizer: trimValue },
      'contact[phone]': { required: true, phoneCustom: true, normalizer: trimValue },
      'contact[company]': { required: true, normalizer: trimValue },

      'contact[billing_address]': { required: true, normalizer: trimValue },
      'contact[billing_city]': { required: true, normalizer: trimValue },
      'contact[billing_state]': { required: true, normalizer: trimValue },
      'contact[billing_country]': { required: true, normalizer: trimValue },
      'contact[billing_zip]': { required: true, normalizer: trimValue },

      'contact[purchasing_for_business]': { required: true },
      'contact[has_account]': { required: true },

      'contact[shipping_address]': {
        required: function () {
          return !$('#same_as_billing').is(':checked');
        },
        normalizer: trimValue
      },
      'contact[shipping_city]': {
        required: function () {
          return !$('#same_as_billing').is(':checked');
        },
        normalizer: trimValue
      },
      'contact[shipping_state]': {
        required: function () {
          return !$('#same_as_billing').is(':checked');
        },
        normalizer: trimValue
      },
      'contact[shipping_country]': {
        required: function () {
          return !$('#same_as_billing').is(':checked');
        },
        normalizer: trimValue
      },
      'contact[shipping_zip]': {
        required: function () {
          return !$('#same_as_billing').is(':checked');
        },
        normalizer: trimValue
      },

      'contact[tax_certificate]': {
        // required: function () {
        //   const business = $('.q-business:checked').val();
        //   const account = $('.q-account:checked').val();
        //   return !(business === 'No' && account === 'No');
        // },
        required: false,
        fileType: true,
      },

      'contact[agree_terms]': {
        required: true,
      },
    },

    messages: {
      name: 'Name is required',
      email: {
        required: 'Email is required',
        email: 'Enter a valid email',
      },
      phone: {
        required: 'Phone is required',
      },
      company: 'Company is required',

      billing_address: 'Billing address is required',
      billing_city: 'Billing city is required',
      billing_state: 'Billing state is required',
      billing_country: 'Billing country is required',
      billing_zip: 'Billing zip is required',

      shipping_address: 'Shipping address is required',
      shipping_city: 'Shipping city is required',
      shipping_state: 'Shipping state is required',
      shipping_country: 'Shipping country is required',
      shipping_zip: 'Shipping zip is required',
      'contact[agree_terms]': 'You must accept terms',
    },
  });

  registerForm.on('submit', function (e) {
    e.preventDefault();

    if (!registerForm.valid()) return;

    const formEl = this;
    const formData = new FormData(formEl);
    const countryMap = {
      'United States': 'US',
    }
    if ($('#same_as_billing').is(':checked')) {
    formData.set("contact[same_as_billing]", true);
    formData.set(
      'contact[shipping_address]',
      formData.get('contact[billing_address]')
    );
    formData.set(
      'contact[shipping_city]',
      formData.get('contact[billing_city]')
    );
    const rawPhone = formData.get('contact[phone]') || '';
    if(rawPhone){
      let digits = rawPhone.replace(/\D/g, '');
      if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.substring(1);
      }
      digits = digits.substring(0, 10);
      let formattedPhone = '';
      if (digits.length === 10) {
        formattedPhone = `+1-${digits.substring(0, 3)}-${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else {
        formattedPhone = '+1-' + digits;
      }
      formData.set('contact[phone]', formattedPhone);
    }

    const billingCountry = formData.get('contact[billing_country]');
    if (countryMap[billingCountry]) {
      formData.set('contact[billing_country]', countryMap[billingCountry]);
    }
    const shippingCountry = formData.get('contact[shipping_country]');
    if (countryMap[shippingCountry]) {
      formData.set('contact[shipping_country]', countryMap[shippingCountry]);
    }
    formData.set(
      'contact[shipping_state]',
      formData.get('contact[billing_state]')
    );
    formData.set(
      'contact[shipping_zip]',
      formData.get('contact[billing_zip]')
    );
  }

  const submitBtn = $(formEl).find('button[type="submit"]');
  submitBtn.addClass('loading').prop('disabled', true);

    $('.wholesale-grid .form-error-global').hide();
    $('.wholesale-grid .form-success-message').hide();

    // new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     const isSuccess = true; // 👈 change this
    //     if (isSuccess) {
    //       resolve({
    //         ok: true,
    //         json: async () => ({
    //           success: true,
    //           message: "Mock success",
    //         }),
    //       });
    //     } else {
    //       resolve({
    //         ok: false,
    //         json: async () => ({
    //           success: false,
    //           errors: {
    //             'contact[email]': 'Email already exists',
    //             'contact[phone]': 'Invalid phone',
    //           },
    //         }),
    //       });
    //     }
    //   }, 1000);
    // }).then(async (res) => {


    fetch(formEl.action, {
      method: 'POST',
      body: formData,
    })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok || !data.success) {
        throw data;
      }

      const form = $('#RegistrationForm');
      const defaultHeading = $('.wholesale-grid .form-default-heading');
      const successHeading = $('.wholesale-grid .form-success-heading');
      const successBox = $('.wholesale-grid .form-success-message');

      // const wholesaleWrapper = document.querySelector('.wholesale-wrapper');
      // if (!wholesaleWrapper) return;

      // const wholesaleSection = wholesaleWrapper.closest('.shopify-section');
      // if (!wholesaleSection) return;

      // wholesaleSection.classList.add('success-submission');
      // const featureGridSection = document.querySelector('.shopify-section[id*="feature_grid"]');

      // if (!featureGridSection) return;
      // featureGridSection.parentNode.insertBefore(
      //   wholesaleSection,
      //   featureGridSection
      // );

      form.hide();
      successBox.show();
      defaultHeading.hide();
      successHeading.show();

      $('html, body').animate({
        scrollTop: $('.register-title').offset().top - 100,
      }, 400);
    }).catch((err) => {
      console.error(err);
      $('.wholesale-grid .form-error-global').hide().text('');
      $('.wholesale-grid .form-field .form-error').text('').hide();

      if (err.message && !err.errors) {
        $('.wholesale-grid .form-error-global')
          .text(err.message || 'Something went wrong')
          .show();
        return;
      }

      if (err.errors) {
        Object.entries(err.errors).forEach(([name, message]) => {
          const input = $(`[name="${name}"]`);
          if (!input.length) return;

          const field = input.closest('.form-field');

          const errorId = input.attr('aria-describedby');
          let errorEl = errorId ? $('#' + errorId) : null;

          if (errorEl && errorEl.length) {
            errorEl.text(message).show();
          } else {
            errorEl = field.find('.form-error').first();

            if (errorEl.length) {
              errorEl.text(message).show();
            } else {
              field.append(`<span class="form-error">${message}</span>`);
            }
          }

          input.css('border-color', 'red');
        });

        const firstError = $('.wholesale-grid .form-error:visible').first();
        if (firstError.length) {
          $('html, body').animate({
            scrollTop: firstError.offset().top - 120,
          }, 400);
        }
      } else {
        $('.wholesale-grid .form-error-global').show();
      }
    }).finally(() => {
      submitBtn.removeClass('loading').prop('disabled', false);
    });
  });
});

/* B2B Registration Form code Ends */


function initLoopWidget({ productId, productData }) {
  return (async () => {
    try {
      if (!productId) return;

      window.LOOP_WIDGET = window.LOOP_WIDGET || {};

      if (window.LOOP_WIDGET[productId]) {
        cleanupLoopWidget(productId);
      }

      window.LOOP_WIDGET[productId] = {
        product: productData,
        selectedVariantId: null,
        selectedSellingPlanId: null,
      };

      await waitForLoopContainer(productId);

      await LoopSubscriptions.startLoopWidget(productId);

    } catch (err) {
      console.error('[Loop] Init failed:', err);
    }
  })();
}
function cleanupLoopWidget(productId) {
  const state = window.LOOP_WIDGET?.[productId];
  if (!state) return;

  if (state.observers?.length) {
    state.observers.forEach(o => o.disconnect());
  }

  const container = document.getElementById(`loop-widget-container-id-${productId}`);
  if (container) {
    container.innerHTML = '';
    container.classList.add('loop-display-none');
  }

  const styleEl = document.getElementById(`loop-widget-styles-id-${productId}`);
  if (styleEl) styleEl.remove();

  delete state.loopWidgetProductForms;
  delete state.addToCartButtons;

  delete window.LOOP_WIDGET[productId];
}
function waitForLoopContainer(productId, timeout = 4000) {
  return new Promise((resolve, reject) => {
    const selector = `#loop-widget-container-id-${productId}`;
    let elapsed = 0;

    const timer = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(timer);
        resolve(el);
      }

      elapsed += 50;
      if (elapsed >= timeout) {
        clearInterval(timer);
        reject(`Loop container not found: ${selector}`);
      }
    }, 50);
  });
}